function createURL(mode, commonData) {
    const requestURL = "https://www.account-t.nissay.co.jp/trshinkeisdir/transactions/menu_direct?selectmenu=2C72030&"
    const editURL = "./index.html"
    //キャンペーン開始時に正式なURLに修正
    const campaignURL = "./campaign.html?";

    const urlParams = {};
    let queryString = "";
    let sendURL = "";
    if (mode == 1) {
        if (commonData.kr != "") urlParams["kr"] = commonData.kr;
        if (commonData.kjc != "") urlParams["kjc"] = commonData.kjc;
        if (commonData.ssc != "") urlParams["ssc"] = commonData.ssc;
        if (commonData.smc != "") urlParams["smc"] = commonData.smc;
        queryString = new URLSearchParams(urlParams).toString();
        if(!queryString == ""){
            queryString = "?" + queryString;
        }
        sendURL = editURL + queryString;
    } else if (mode == 2) {
        if (commonData.kr != "") urlParams["kr"] = commonData.kr;
        if (commonData.kjc != "") urlParams["kjc"] = commonData.kjc;
        if (commonData.ssc != "") urlParams["ssc"] = commonData.ssc;
        if (commonData.smc != "") urlParams["smc"] = commonData.smc;
        if (commonData.hymd != "") urlParams["hymd"] = commonData.hymd;
        if (commonData.sex != "") urlParams["hs"] = commonData.sex;
        if (commonData.stp != "") urlParams["stp"] = commonData.stp;
        if (commonData.sts != "") urlParams["sts"] = commonData.sts;
        queryString = new URLSearchParams(urlParams).toString();
        if(!queryString == ""){
            queryString = "?" + queryString;
        }
        sendURL = editURL + queryString;
    } else if (mode == 3) {
        if (commonData.kr != "") urlParams["kr"] = commonData.kr;
        if (commonData.kjc != "") urlParams["kjc"] = commonData.kjc;
        if (commonData.ssc != "") urlParams["ssc"] = commonData.ssc;
        if (commonData.smc != "") urlParams["smc"] = commonData.smc;
        if (commonData.hymd != "") urlParams["hymd"] = commonData.hymd;
        if (commonData.sex != "") urlParams["hs"] = commonData.sex;
        if (commonData.stp != "") urlParams["stp"] = commonData.stp;
        if (commonData.sts != "") urlParams["sts"] = commonData.sts;
        if (commonData.lymd != "") urlParams["lymd"] = commonData.lymd;
        queryString = new URLSearchParams(urlParams).toString()
        sendURL = requestURL + queryString
    } else if (mode == 4) {
        //キャンペーン対応で使用するロジック
        if (commonData.kr != "") urlParams["kr"] = commonData.kr;
        if (commonData.kjc != "") urlParams["kjc"] = commonData.kjc;
        if (commonData.ssc != "") urlParams["ssc"] = commonData.ssc;
        if (commonData.smc != "") urlParams["smc"] = commonData.smc;
        if (commonData.hymd != "") urlParams["hymd"] = commonData.hymd;
        if (commonData.sex != "") urlParams["hs"] = commonData.sex;
        if (commonData.stp != "") urlParams["stp"] = commonData.stp;
        if (commonData.sts != "") urlParams["sts"] = commonData.sts;
        if (commonData.lymd != "") urlParams["lymd"] = commonData.lymd;
        queryString = new URLSearchParams(urlParams).toString();
        sendURL = campaignURL + queryString;
    }

    return sendURL
}

export default { createURL }

